module.exports = __webpack_public_path__ + "static/ugovor-b511007d522085531c07979d649476cc.svg";